/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { TABLE_SIZE } from './FOCellTypes';

export function TableConfig(
  size = TABLE_SIZE.SMALL,
  hasHeader = true,
  hasFooter = true,
  emptyTableCol = 7,
  xlEmptyTableCol = 8,
  isExtraLargeOrBigger = true,
) {
  this.size = size;
  this.hasHeader = hasHeader;
  this.hasFooter = hasFooter;
  this.emptyTableCol = emptyTableCol;
  this.xlEmptyTableCol = xlEmptyTableCol;
  this.isExtraLargeOrBigger = isExtraLargeOrBigger;
}

function TableConfigBuilder() {
  return {
    setSize(_size) {
      this.size = _size;
      return this;
    },
    setHasHeader(_hasHeader) {
      this.hasHeader = _hasHeader;
      return this;
    },
    setHasFooter(_hasFooter) {
      this.hasFooter = _hasFooter;
      return this;
    },
    setXlEmptyCol(_xlEmptyTableCol) {
      this.xlEmptyTableCol = _xlEmptyTableCol;
      return this;
    },
    setEmptyTableCol(_emptyTableCol) {
      this.emptyTableCol = _emptyTableCol;
      return this;
    },
    setExtraLargeOrBigger(_isExtraLargeOrBigger) {
      this.isExtraLargeOrBigger = _isExtraLargeOrBigger;
      return this;
    },
    build() {
      return new TableConfig(
        this.size,
        this.hasHeader,
        this.hasFooter,
        this.emptyTableCol,
        this.xlEmptyTableCol,
        this.isExtraLargeOrBigger,
      );
    },
  };
}

export default TableConfigBuilder;
